import _ from 'lodash';
import { setDualViewRedirect } from '@/router/index.js';
import { getDualViewDefaultTab } from '@/utils/dual-view-setting.js';
import { getAnalyticsDualViewSetting } from 'library-@/apis/core_basic_api/view.js';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { DualViewSettingService } from '@/domains/dual-view/services/dual-view-setting-service';
import type { DualViewSetting } from '@/domains/dual-view/types';

export async function initializeDualViewSetting(enabledFetchSetting: boolean) {
    const dualViewSettingService = injectService<DualViewSettingService>(DualViewSettingService);

    let dualViewSetting = {};

    if (enabledFetchSetting) {
        try {
            dualViewSetting = await getAnalyticsDualViewSetting() || {};
        } catch (e) {
            console.log(e);
        }
    }

    const dualViewDefaultTab = getDualViewDefaultTab(dualViewSetting);

    setDualViewRedirect(dualViewDefaultTab.left, dualViewDefaultTab.right);

    // 更新双视图设置
    if (!_.isEmpty(dualViewSetting)) {
        dualViewSettingService.updateSetting(dualViewSetting as DualViewSetting);
    }
}
